import cityBtnModal from './components/city-btn-modal';
import common from './components/common';
import Main from './main';

const Videos = {}

Main.init()
common.backToTopButton()
cityBtnModal.init()

// const x = document.querySelector("#background-video");

// window.onscroll = function () {
//   visiblePlayer(x)
// }

// const visiblePlayer = (el) => {
//   const posicoes = el.getBoundingClientRect();
//   const inicio = posicoes.top;
//   const fim = posicoes.bottom;
//   let visiblePlayer = false
//   var video = video('player-video');
//   var video_container = document.getElementById("video-container");
//   var video_player = document.getElementById("player-video");
//   var close_video = document.getElementById("close-video");

//   if ((inicio <= window.innerHeight) && (fim >= 0)) {
//     visiblePlayer = true;
//     if (!video.paused() && video_player.classList.contains("video-pip")) {
//       video_container.classList.remove("video-pip");
//       video_player.classList.remove("video-pip");
//       close_video.classList.remove("close-video");
//       video.fluid(true);
//       //video.pause();
//     }
//   } else {
//     if (!video.paused() && !video_player.classList.contains("video-pip")) {
//       video_player.classList.add("video-pip");
//       video.fluid(false);
//       video_container.classList.add("video-pip");
//       close_video.classList.add("close-video");
//     }
//   }
//   return visiblePlayer;
// }

// const btnClosePip = document.getElementById("closePip")
// btnClosePip.addEventListener('click', closePip)

// function closePip() {
//   var video = videojs('player-video');
//   var video_container = document.getElementById("video-container");
//   var video_player = document.getElementById("player-video");
//   var close_video = document.getElementById("close-video");

//   video_container.classList.remove("video-pip");
//   video_player.classList.remove("video-pip");
//   close_video.classList.remove("close-video");

//   video.fluid(true);
//   video.ima.pauseAd();
//   video.pause();
// }